import { z } from 'zod';

/**
 * Zod schema for the persisted per-table column preferences. Used by the
 * storage layer to validate whatever was read back — a parse failure is
 * treated as "no preferences" so a corrupt entry never breaks a table.
 */
export const tablePreferencesSchema = z.object({
  /** Column ids in display order (includes system columns like `select`/`options`). */
  columnOrder: z.array(z.string()),
  /** Column id -> visible. A missing entry means visible. */
  columnVisibility: z.record(z.string(), z.boolean()),
  /** Column id -> width in px. A missing entry means the backend default size. */
  columnSizing: z.record(z.string(), z.number()),
});

export type TablePreferences = z.infer<typeof tablePreferencesSchema>;
